import React from 'react';
import { SearchResultField, LinkField } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { get } from 'lodash';
import { useVendorsUrl } from 'domain/finance/vendors/routes';

// Delete in a future
const TempInvoiceVendorNameField = ({ nameSource, vendorSource, vendorNameSource, ...props }: any) => {
  const { data } = useShowContext();
  const oldNameValue = get(data.getData(), nameSource);
  const newNameValue = get(data.getData(), vendorNameSource);
  const vendorId = get(data.getData(), vendorSource);

  const { getSingleEntityUrl } = useVendorsUrl();

  return vendorId && newNameValue ? (
    <LinkField linkText={newNameValue} value={getSingleEntityUrl(vendorId)} />
  ) : (
    <SearchResultField value={newNameValue || oldNameValue} />
  );
};

export default TempInvoiceVendorNameField;
